import { render, staticRenderFns } from "./SignInH5BNew.vue?vue&type=template&id=485ad602&scoped=true&"
import script from "./SignInH5BNew.vue?vue&type=script&lang=js&"
export * from "./SignInH5BNew.vue?vue&type=script&lang=js&"
import style0 from "./SignInH5BNew.vue?vue&type=style&index=0&id=485ad602&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485ad602",
  null
  
)

export default component.exports